import React from "react";

import Contact from "../Contact/Contact";

const ContactPage = () => {
    return (
        <div className="single-page" style={{ marginTop: 0 }}>
            <Contact />
        </div>
    );
};

export default ContactPage;
